import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertInterface } from '../../interfaces/alert.interface';

@Component({
  selector: 'app-carousel',
  animations: [
    trigger('troca', [
      state(
        'aparece',
        style({
          opacity: 1
        })
      ),
      state(
        'some',
        style({
          opacity: 0
        })
      ),
      transition('aparece => some', [
        animate(
          '200ms',
          keyframes([
            style({ opacity: 1 }),
            style({ opacity: 0.75 }),
            style({ opacity: 0.5 }),
            style({ opacity: 0.25 }),
            style({ opacity: 0 })
          ])
        )
      ]),
      transition('some => aparece', [
        animate(
          '200ms',
          keyframes([
            style({ opacity: 0 }),
            style({ opacity: 0.25 }),
            style({ opacity: 0.5 }),
            style({ opacity: 0.75 }),
            style({ opacity: 1 })
          ])
        )
      ])
    ])
  ],
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  @Input() alertsData: AlertInterface[];
  @Input() userAlerts: AlertInterface[];

  alerta: AlertInterface;
  index = 0;
  timer: any;
  muda = true;

  @ViewChild('panel') public panel: ElementRef;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.alerta = this.userAlerts[0];
    this.carrosselInicia();
  }

  temporizador() {
    setTimeout(() => {
      this.muda = true;

      this.alerta = this.userAlerts[this.index];
    }, 450);
  }

  carrossel() {
    this.muda = false;
    if (this.index >= this.userAlerts.length - 1) {
      this.index = 0;
    } else {
      this.index++;
    }
    this.temporizador();
  }

  carrosselInicia() {
    if (this.userAlerts.length > 1) this.timer = setInterval(() => this.carrossel(), 10000);
  }

  carrosselPara() {
    clearInterval(this.timer);
  }

  proximo() {
    if (this.userAlerts.length > 1) {
      this.carrosselPara();
      this.muda = false;
      if (this.index >= this.userAlerts.length - 1) {
        this.index = 0;
      } else {
        this.index++;
      }
      this.temporizador();
      this.carrosselInicia();
    }
  }

  anterior() {
    if (this.userAlerts.length > 1) {
      this.carrosselPara();
      this.muda = false;
      if (this.index <= 0) {
        this.index = this.userAlerts.length - 1;
      } else {
        this.index--;
      }
      this.temporizador();
      this.carrosselInicia();
    }
  }

  vai(i: number) {
    this.carrosselPara();

    this.muda = false;
    this.index = i;
    this.temporizador();

    this.carrosselInicia();
  }
  ativo(i: number) {
    return i == this.index;
  }
}
